import Schema from 'validate';

const NachrichtFieldsValidator = new Schema({
	Foerderantrag: {
		type: Number,
		required: true,
	},
	Foerderprogramm: {
		type: Number,
	},
	Allgemein_Betreff: {
		type: String,
		required: true,
	},
	Allgemein_Inhalt: {
		type: String,
		required: true,
	},
});

NachrichtFieldsValidator.message({
	required: (_path) => 'Pflichtfeld.',
	type: (path) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
});

export default NachrichtFieldsValidator;
